const durations = [
    {
        "data": [
            {
                "symbol": [
                    { "display_name": "AUD/JPY", "name": "frxAUDJPY" },
                    { "display_name": "AUD/USD", "name": "frxAUDUSD" },
                    { "display_name": "EUR/AUD", "name": "frxEURAUD" },
                    { "display_name": "EUR/CAD", "name": "frxEURCAD" },
                    { "display_name": "EUR/CHF", "name": "frxEURCHF" },
                    { "display_name": "EUR/GBP", "name": "frxEURGBP" },
                    { "display_name": "EUR/JPY", "name": "frxEURJPY" },
                    { "display_name": "EUR/USD", "name": "frxEURUSD" },
                    { "display_name": "GBP/AUD", "name": "frxGBPAUD" },
                    { "display_name": "GBP/JPY", "name": "frxGBPJPY" },
                    { "display_name": "GBP/USD", "name": "frxGBPUSD" },
                    { "display_name": "USD/CAD", "name": "frxUSDCAD" },
                    { "display_name": "USD/CHF", "name": "frxUSDCHF" },
                    { "display_name": "USD/JPY", "name": "frxUSDJPY" }
                ],
                "trade_durations": [
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 15, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" },
                            { "display_name": "Days", "max": 365, "min": 1, "name": "days" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall", "name": "rise_fall" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 15, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall (Forward Start)", "name": "rise_fall_forward" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 15, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" },
                            { "display_name": "Days", "max": 365, "min": 1, "name": "days" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall Equal", "name": "rise_fall_equal" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 15, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall Equal (Forward Start)", "name": "rise_fall_equal_forward" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 1, "name": "days" }],
                        "trade_type": { "display_name": "Higher/Lower", "name": "higher_lower" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 1, "name": "days" }],
                        "trade_type": { "display_name": "Touch/No Touch", "name": "touchnotouch" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 1, "name": "days" }],
                        "trade_type": { "display_name": "Ends Between/Ends Outside", "name": "endsinout" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 1, "name": "days" }],
                        "trade_type": { "display_name": "Stays Between/Goes Outside", "name": "staysinout" }
                    },
                    {
                        "durations": [{ "display_name": "No Expiry", "max": 0, "min": 0, "name": "no_expiry" }],
                        "trade_type": { "display_name": "Multiply Up/Multiply Down", "name": "multiplier" }
                    }
                ]
            }
        ],
        "market": { "display_name": "Forex", "name": "forex" },
        "submarket": { "display_name": "Major Pairs", "name": "major_pairs" }
    },
    {
        "data": [
            {
                "symbol": [
                    { "display_name": "GBP/NOK", "name": "frxGBPNOK" },
                    { "display_name": "USD/NOK", "name": "frxUSDNOK" },
                    { "display_name": "USD/SEK", "name": "frxUSDSEK" }
                ],
                "trade_durations": [
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 15, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall (Forward Start)", "name": "rise_fall_forward" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 15, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall Equal (Forward Start)", "name": "rise_fall_equal_forward" }
                    }
                ]
            },
            {
                "symbol": [
                    { "display_name": "AUD/CAD", "name": "frxAUDCAD" },
                    { "display_name": "AUD/CHF", "name": "frxAUDCHF" },
                    { "display_name": "AUD/NZD", "name": "frxAUDNZD" },
                    { "display_name": "EUR/NZD", "name": "frxEURNZD" },
                    { "display_name": "GBP/CAD", "name": "frxGBPCAD" },
                    { "display_name": "GBP/CHF", "name": "frxGBPCHF" },
                    { "display_name": "GBP/NZD", "name": "frxGBPNZD" },
                    { "display_name": "NZD/USD", "name": "frxNZDUSD" }
                ],
                "trade_durations": [
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 15, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" },
                            { "display_name": "Days", "max": 365, "min": 1, "name": "days" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall", "name": "rise_fall" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 15, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall (Forward Start)", "name": "rise_fall_forward" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 15, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" },
                            { "display_name": "Days", "max": 365, "min": 1, "name": "days" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall Equal", "name": "rise_fall_equal" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 15, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall Equal (Forward Start)", "name": "rise_fall_equal_forward" }
                    }
                ]
            },
            {
                "symbol": [
                    { "display_name": "NZD/JPY", "name": "frxNZDJPY" },
                    { "display_name": "USD/MXN", "name": "frxUSDMXN" },
                    { "display_name": "USD/PLN", "name": "frxUSDPLN" }
                ],
                "trade_durations": [
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 1, "name": "days" }],
                        "trade_type": { "display_name": "Rise/Fall", "name": "rise_fall" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 15, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall (Forward Start)", "name": "rise_fall_forward" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 1, "name": "days" }],
                        "trade_type": { "display_name": "Rise/Fall Equal", "name": "rise_fall_equal" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 15, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall Equal (Forward Start)", "name": "rise_fall_equal_forward" }
                    }
                ]
            }
        ],
        "market": { "display_name": "Forex", "name": "forex" },
        "submarket": { "display_name": "Minor Pairs", "name": "minor_pairs" }
    },
    {
        "data": [
            {
                "symbol": [{ "display_name": "Japan 225", "name": "OTC_N225" }],
                "trade_durations": [
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 60, "min": 30, "name": "m" },
                            { "display_name": "Hours", "max": 1, "min": 1, "name": "h" },
                            { "display_name": "Days", "max": 365, "min": 1, "name": "days" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall", "name": "rise_fall" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 30, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall (Forward Start)", "name": "rise_fall_forward" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 7, "name": "days" }],
                        "trade_type": { "display_name": "Higher/Lower", "name": "higher_lower" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 7, "name": "days" }],
                        "trade_type": { "display_name": "Touch/No Touch", "name": "touchnotouch" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 7, "name": "days" }],
                        "trade_type": { "display_name": "Ends Between/Ends Outside", "name": "endsinout" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 7, "name": "days" }],
                        "trade_type": { "display_name": "Stays Between/Goes Outside", "name": "staysinout" }
                    }
                ]
            },
            {
                "symbol": [
                    { "display_name": "Australia 200", "name": "OTC_AS51" },
                    { "display_name": "Hong Kong 50", "name": "OTC_HSI" }
                ],
                "trade_durations": [
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 60, "min": 15, "name": "m" },
                            { "display_name": "Hours", "max": 1, "min": 1, "name": "h" },
                            { "display_name": "Days", "max": 365, "min": 1, "name": "days" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall", "name": "rise_fall" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 15, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall (Forward Start)", "name": "rise_fall_forward" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 7, "name": "days" }],
                        "trade_type": { "display_name": "Higher/Lower", "name": "higher_lower" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 7, "name": "days" }],
                        "trade_type": { "display_name": "Touch/No Touch", "name": "touchnotouch" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 7, "name": "days" }],
                        "trade_type": { "display_name": "Ends Between/Ends Outside", "name": "endsinout" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 7, "name": "days" }],
                        "trade_type": { "display_name": "Stays Between/Goes Outside", "name": "staysinout" }
                    }
                ]
            }
        ],
        "market": { "display_name": "Stock Indices", "name": "indices" },
        "submarket": { "display_name": "Asian indices", "name": "asia_oceania_OTC" }
    },
    {
        "data": [
            {
                "symbol": [
                    { "display_name": "Netherlands 25", "name": "OTC_AEX" },
                    { "display_name": "Euro 50", "name": "OTC_SX5E" }
                ],
                "trade_durations": [
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 60, "min": 30, "name": "m" },
                            { "display_name": "Hours", "max": 1, "min": 1, "name": "h" },
                            { "display_name": "Days", "max": 365, "min": 1, "name": "days" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall", "name": "rise_fall" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 30, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall (Forward Start)", "name": "rise_fall_forward" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 7, "name": "days" }],
                        "trade_type": { "display_name": "Higher/Lower", "name": "higher_lower" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 7, "name": "days" }],
                        "trade_type": { "display_name": "Touch/No Touch", "name": "touchnotouch" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 7, "name": "days" }],
                        "trade_type": { "display_name": "Ends Between/Ends Outside", "name": "endsinout" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 7, "name": "days" }],
                        "trade_type": { "display_name": "Stays Between/Goes Outside", "name": "staysinout" }
                    }
                ]
            },
            {
                "symbol": [
                    { "display_name": "France 40", "name": "OTC_FCHI" },
                    { "display_name": "UK 100", "name": "OTC_FTSE" },
                    { "display_name": "Germany 40", "name": "OTC_GDAXI" },
                    { "display_name": "Swiss 20", "name": "OTC_SSMI" }
                ],
                "trade_durations": [
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 60, "min": 15, "name": "m" },
                            { "display_name": "Hours", "max": 1, "min": 1, "name": "h" },
                            { "display_name": "Days", "max": 365, "min": 1, "name": "days" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall", "name": "rise_fall" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 15, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall (Forward Start)", "name": "rise_fall_forward" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 7, "name": "days" }],
                        "trade_type": { "display_name": "Higher/Lower", "name": "higher_lower" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 7, "name": "days" }],
                        "trade_type": { "display_name": "Touch/No Touch", "name": "touchnotouch" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 7, "name": "days" }],
                        "trade_type": { "display_name": "Ends Between/Ends Outside", "name": "endsinout" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 7, "name": "days" }],
                        "trade_type": { "display_name": "Stays Between/Goes Outside", "name": "staysinout" }
                    }
                ]
            }
        ],
        "market": { "display_name": "Stock Indices", "name": "indices" },
        "submarket": { "display_name": "European indices", "name": "europe_OTC" }
    },
    {
        "data": [
            {
                "symbol": [
                    { "display_name": "Wall Street 30", "name": "OTC_DJI" },
                    { "display_name": "US Tech 100", "name": "OTC_NDX" },
                    { "display_name": "US 500", "name": "OTC_SPC" }
                ],
                "trade_durations": [
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 60, "min": 15, "name": "m" },
                            { "display_name": "Hours", "max": 1, "min": 1, "name": "h" },
                            { "display_name": "Days", "max": 365, "min": 1, "name": "days" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall", "name": "rise_fall" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 15, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall (Forward Start)", "name": "rise_fall_forward" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 7, "name": "days" }],
                        "trade_type": { "display_name": "Higher/Lower", "name": "higher_lower" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 7, "name": "days" }],
                        "trade_type": { "display_name": "Touch/No Touch", "name": "touchnotouch" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 7, "name": "days" }],
                        "trade_type": { "display_name": "Ends Between/Ends Outside", "name": "endsinout" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 7, "name": "days" }],
                        "trade_type": { "display_name": "Stays Between/Goes Outside", "name": "staysinout" }
                    }
                ]
            }
        ],
        "market": { "display_name": "Stock Indices", "name": "indices" },
        "submarket": { "display_name": "American indices", "name": "americas_OTC" }
    },
    {
        "data": [
            {
                "symbol": [
                    { "display_name": "Silver/USD", "name": "frxXAGUSD" },
                    { "display_name": "Gold/USD", "name": "frxXAUUSD" }
                ],
                "trade_durations": [
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 5, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" },
                            { "display_name": "Days", "max": 365, "min": 1, "name": "days" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall", "name": "rise_fall" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 5, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall (Forward Start)", "name": "rise_fall_forward" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 1, "name": "days" }],
                        "trade_type": { "display_name": "Higher/Lower", "name": "higher_lower" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 1, "name": "days" }],
                        "trade_type": { "display_name": "Touch/No Touch", "name": "touchnotouch" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 7, "name": "days" }],
                        "trade_type": { "display_name": "Ends Between/Ends Outside", "name": "endsinout" }
                    },
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 7, "name": "days" }],
                        "trade_type": { "display_name": "Stays Between/Goes Outside", "name": "staysinout" }
                    },
                    {
                        "durations": [{ "display_name": "No Expiry", "max": 0, "min": 0, "name": "no_expiry" }],
                        "trade_type": { "display_name": "Multiply Up/Multiply Down", "name": "multiplier" }
                    }
                ]
            },
            {
                "symbol": [
                    { "display_name": "Palladium/USD", "name": "frxXPDUSD" },
                    { "display_name": "Platinum/USD", "name": "frxXPTUSD" }
                ],
                "trade_durations": [
                    {
                        "durations": [{ "display_name": "Days", "max": 365, "min": 1, "name": "days" }],
                        "trade_type": { "display_name": "Rise/Fall", "name": "rise_fall" }
                    }
                ]
            }
        ],
        "market": { "display_name": "Commodities", "name": "commodities" },
        "submarket": { "display_name": "Metals", "name": "metals" }
    },
    {
        "data": [
            {
                "symbol": [
                    { "display_name": "Volatility 10 (1s) Index", "name": "1HZ10V" },
                    { "display_name": "Volatility 15 (1s) Index", "name": "1HZ15V" },
                    { "display_name": "Volatility 25 (1s) Index", "name": "1HZ25V" },
                    { "display_name": "Volatility 30 (1s) Index", "name": "1HZ30V" },
                    { "display_name": "Volatility 50 (1s) Index", "name": "1HZ50V" },
                    { "display_name": "Volatility 75 (1s) Index", "name": "1HZ75V" },
                    { "display_name": "Volatility 90 (1s) Index", "name": "1HZ90V" },
                    { "display_name": "Volatility 100 (1s) Index", "name": "1HZ100V" },
                    { "display_name": "Volatility 10 Index", "name": "R_10" },
                    { "display_name": "Volatility 25 Index", "name": "R_25" },
                    { "display_name": "Volatility 50 Index", "name": "R_50" },
                    { "display_name": "Volatility 75 Index", "name": "R_75" },
                    { "display_name": "Volatility 100 Index", "name": "R_100" }
                ],
                "trade_durations": [
                    {
                        "durations": [
                            { "display_name": "Ticks", "max": 10, "min": 1, "name": "ticks" },
                            { "display_name": "Seconds", "max": 86400, "min": 15, "name": "s" },
                            { "display_name": "Minutes", "max": 1440, "min": 1, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" },
                            { "display_name": "Days", "max": 365, "min": 1, "name": "days" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall", "name": "rise_fall" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 2, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall (Forward Start)", "name": "rise_fall_forward" }
                    },
                    {
                        "durations": [
                            { "display_name": "Ticks", "max": 10, "min": 1, "name": "ticks" },
                            { "display_name": "Seconds", "max": 86400, "min": 15, "name": "s" },
                            { "display_name": "Minutes", "max": 1440, "min": 1, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" },
                            { "display_name": "Days", "max": 365, "min": 1, "name": "days" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall Equal", "name": "rise_fall_equal" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 2, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall Equal (Forward Start)", "name": "rise_fall_equal_forward" }
                    },
                    {
                        "durations": [
                            { "display_name": "Ticks", "max": 10, "min": 5, "name": "ticks" },
                            { "display_name": "Seconds", "max": 86400, "min": 15, "name": "s" },
                            { "display_name": "Minutes", "max": 1440, "min": 1, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" },
                            { "display_name": "Days", "max": 365, "min": 1, "name": "days" }
                        ],
                        "trade_type": { "display_name": "Higher/Lower", "name": "higher_lower" }
                    },
                    {
                        "durations": [
                            { "display_name": "Ticks", "max": 10, "min": 5, "name": "ticks" },
                            { "display_name": "Minutes", "max": 1440, "min": 2, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" },
                            { "display_name": "Days", "max": 365, "min": 1, "name": "days" }
                        ],
                        "trade_type": { "display_name": "Touch/No Touch", "name": "touchnotouch" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 2, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" },
                            { "display_name": "Days", "max": 365, "min": 1, "name": "days" }
                        ],
                        "trade_type": { "display_name": "Ends Between/Ends Outside", "name": "endsinout" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 2, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" },
                            { "display_name": "Days", "max": 365, "min": 1, "name": "days" }
                        ],
                        "trade_type": { "display_name": "Stays Between/Goes Outside", "name": "staysinout" }
                    },
                    {
                        "durations": [{ "display_name": "Ticks", "max": 10, "min": 1, "name": "ticks" }],
                        "trade_type": { "display_name": "Digits", "name": "digits" }
                    },
                    {
                        "durations": [{ "display_name": "Ticks", "max": 10, "min": 5, "name": "ticks" }],
                        "trade_type": { "display_name": "Asians", "name": "asian" }
                    },
                    {
                        "durations": [
                            { "display_name": "Ticks", "max": 10, "min": 5, "name": "ticks" },
                            { "display_name": "Seconds", "max": 7200, "min": 20, "name": "s" },
                            { "display_name": "Minutes", "max": 120, "min": 1, "name": "m" },
                            { "display_name": "Hours", "max": 2, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Reset Call/Reset Put", "name": "reset" }
                    },
                    {
                        "durations": [{ "display_name": "Ticks", "max": 5, "min": 5, "name": "ticks" }],
                        "trade_type": { "display_name": "High/Low Ticks", "name": "highlowticks" }
                    },
                    {
                        "durations": [{ "display_name": "Minutes", "max": 30, "min": 1, "name": "m" }],
                        "trade_type": { "display_name": "Lookbacks", "name": "lookback" }
                    },
                    {
                        "durations": [{ "display_name": "Ticks", "max": 5, "min": 2, "name": "ticks" }],
                        "trade_type": { "display_name": "Only Ups/Only Downs", "name": "runs" }
                    },
                    {
                        "durations": [{ "display_name": "No Expiry", "max": 0, "min": 0, "name": "no_expiry" }],
                        "trade_type": { "display_name": "Multiply Up/Multiply Down", "name": "multiplier" }
                    },
                    {
                        "durations": [{ "display_name": "No Expiry", "max": 0, "min": 0, "name": "no_expiry" }],
                        "trade_type": { "display_name": "Accumulator", "name": "accumulator" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 1, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" },
                            { "display_name": "Days", "max": 365, "min": 1, "name": "days" },
                            { "display_name": "Minutes", "max": 1440, "min": 1, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" },
                            { "display_name": "Days", "max": 365, "min": 1, "name": "days" }
                        ],
                        "trade_type": { "display_name": "Vanilla Options", "name": "vanilla" }
                    },
                    {
                        "durations": [
                            { "display_name": "Ticks", "max": 10, "min": 5, "name": "ticks" },
                            { "display_name": "Seconds", "max": 86400, "min": 15, "name": "s" },
                            { "display_name": "Minutes", "max": 1440, "min": 1, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" },
                            { "display_name": "Days", "max": 365, "min": 1, "name": "days" }
                        ],
                        "trade_type": { "display_name": "Turbos Options", "name": "turbos" }
                    }
                ]
            }
        ],
        "market": { "display_name": "Derived", "name": "synthetic_index" },
        "submarket": { "display_name": "Continuous Indices", "name": "random_index" }
    },
    {
        "data": [
            {
                "symbol": [
                    { "display_name": "Bear Market Index", "name": "RDBEAR" },
                    { "display_name": "Bull Market Index", "name": "RDBULL" }
                ],
                "trade_durations": [
                    {
                        "durations": [
                            { "display_name": "Ticks", "max": 10, "min": 1, "name": "ticks" },
                            { "display_name": "Seconds", "max": 86400, "min": 15, "name": "s" },
                            { "display_name": "Minutes", "max": 1440, "min": 1, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall", "name": "rise_fall" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 2, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall (Forward Start)", "name": "rise_fall_forward" }
                    },
                    {
                        "durations": [
                            { "display_name": "Ticks", "max": 10, "min": 1, "name": "ticks" },
                            { "display_name": "Seconds", "max": 86400, "min": 15, "name": "s" },
                            { "display_name": "Minutes", "max": 1440, "min": 1, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall Equal", "name": "rise_fall_equal" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 2, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall Equal (Forward Start)", "name": "rise_fall_equal_forward" }
                    },
                    {
                        "durations": [
                            { "display_name": "Ticks", "max": 10, "min": 5, "name": "ticks" },
                            { "display_name": "Seconds", "max": 86400, "min": 15, "name": "s" },
                            { "display_name": "Minutes", "max": 1440, "min": 1, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Higher/Lower", "name": "higher_lower" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 2, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Touch/No Touch", "name": "touchnotouch" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 2, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Ends Between/Ends Outside", "name": "endsinout" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 2, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Stays Between/Goes Outside", "name": "staysinout" }
                    },
                    {
                        "durations": [{ "display_name": "Ticks", "max": 10, "min": 1, "name": "ticks" }],
                        "trade_type": { "display_name": "Digits", "name": "digits" }
                    }
                ]
            }
        ],
        "market": { "display_name": "Derived", "name": "synthetic_index" },
        "submarket": { "display_name": "Daily Reset Indices", "name": "random_daily" }
    },
    {
        "data": [
            {
                "symbol": [
                    { "display_name": "AUD Basket", "name": "WLDAUD" },
                    { "display_name": "EUR Basket", "name": "WLDEUR" },
                    { "display_name": "GBP Basket", "name": "WLDGBP" },
                    { "display_name": "USD Basket", "name": "WLDUSD" }
                ],
                "trade_durations": [
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 600, "min": 15, "name": "m" },
                            { "display_name": "Hours", "max": 10, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall", "name": "rise_fall" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 600, "min": 15, "name": "m" },
                            { "display_name": "Hours", "max": 10, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall Equal", "name": "rise_fall_equal" }
                    },
                    {
                        "durations": [{ "display_name": "No Expiry", "max": 0, "min": 0, "name": "no_expiry" }],
                        "trade_type": { "display_name": "Multiply Up/Multiply Down", "name": "multiplier" }
                    }
                ]
            }
        ],
        "market": { "display_name": "Derived", "name": "synthetic_index" },
        "submarket": { "display_name": "Forex Basket", "name": "forex_basket" }
    },
    {
        "data": [
            {
                "symbol": [{ "display_name": "Gold Basket", "name": "WLDXAU" }],
                "trade_durations": [
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 600, "min": 15, "name": "m" },
                            { "display_name": "Hours", "max": 10, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall", "name": "rise_fall" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 600, "min": 15, "name": "m" },
                            { "display_name": "Hours", "max": 10, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall Equal", "name": "rise_fall_equal" }
                    },
                    {
                        "durations": [{ "display_name": "No Expiry", "max": 0, "min": 0, "name": "no_expiry" }],
                        "trade_type": { "display_name": "Multiply Up/Multiply Down", "name": "multiplier" }
                    }
                ]
            }
        ],
        "market": { "display_name": "Derived", "name": "synthetic_index" },
        "submarket": { "display_name": "Commodities Basket", "name": "commodity_basket" }
    },
    {
        "data": [
            {
                "symbol": [
                    { "display_name": "Step Index 100", "name": "stpRNG" },
                    { "display_name": "Step Index 200", "name": "stpRNG2" },
                    { "display_name": "Step Index 300", "name": "stpRNG3" },
                    { "display_name": "Step Index 400", "name": "stpRNG4" },
                    { "display_name": "Step Index 500", "name": "stpRNG5" }
                ],
                "trade_durations": [
                    {
                        "durations": [
                            { "display_name": "Ticks", "max": 10, "min": 1, "name": "ticks" },
                            { "display_name": "Seconds", "max": 86400, "min": 15, "name": "s" },
                            { "display_name": "Minutes", "max": 1440, "min": 1, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" },
                            { "display_name": "Days", "max": 365, "min": 1, "name": "days" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall", "name": "rise_fall" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 2, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall (Forward Start)", "name": "rise_fall_forward" }
                    },
                    {
                        "durations": [
                            { "display_name": "Ticks", "max": 10, "min": 1, "name": "ticks" },
                            { "display_name": "Seconds", "max": 86400, "min": 15, "name": "s" },
                            { "display_name": "Minutes", "max": 1440, "min": 1, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" },
                            { "display_name": "Days", "max": 365, "min": 1, "name": "days" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall Equal", "name": "rise_fall_equal" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 2, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall Equal (Forward Start)", "name": "rise_fall_equal_forward" }
                    },
                    {
                        "durations": [{ "display_name": "No Expiry", "max": 0, "min": 0, "name": "no_expiry" }],
                        "trade_type": { "display_name": "Multiply Up/Multiply Down", "name": "multiplier" }
                    }
                ]
            }
        ],
        "market": { "display_name": "Derived", "name": "synthetic_index" },
        "submarket": { "display_name": "Step Indices", "name": "step_index" }
    },
    {
        "data": [
            {
                "symbol": [
                    { "display_name": "Boom 50 Index", "name": "BOOM50" },
                    { "display_name": "Boom 150 Index", "name": "BOOM150N" },
                    { "display_name": "Boom 300 Index", "name": "BOOM300N" },
                    { "display_name": "Boom 500 Index", "name": "BOOM500" },
                    { "display_name": "Boom 600 Index", "name": "BOOM600" },
                    { "display_name": "Boom 900 Index", "name": "BOOM900" },
                    { "display_name": "Boom 1000 Index", "name": "BOOM1000" },
                    { "display_name": "Crash 50 Index", "name": "CRASH50" },
                    { "display_name": "Crash 150 Index", "name": "CRASH150N" },
                    { "display_name": "Crash 300 Index", "name": "CRASH300N" },
                    { "display_name": "Crash 500 Index", "name": "CRASH500" },
                    { "display_name": "Crash 600 Index", "name": "CRASH600" },
                    { "display_name": "Crash 900 Index", "name": "CRASH900" },
                    { "display_name": "Crash 1000 Index", "name": "CRASH1000" }
                ],
                "trade_durations": [
                    {
                        "durations": [{ "display_name": "No Expiry", "max": 0, "min": 0, "name": "no_expiry" }],
                        "trade_type": { "display_name": "Multiply Up/Multiply Down", "name": "multiplier" }
                    },
                    {
                        "durations": [{ "display_name": "No Expiry", "max": 0, "min": 0, "name": "no_expiry" }],
                        "trade_type": { "display_name": "Accumulator", "name": "accumulator" }
                    }
                ]
            }
        ],
        "market": { "display_name": "Derived", "name": "synthetic_index" },
        "submarket": { "display_name": "Crash/Boom Indices", "name": "crash_index" }
    },
    {
        "data": [
            {
                "symbol": [
                    { "display_name": "Range Break 100 Index", "name": "RB100" },
                    { "display_name": "Range Break 200 Index", "name": "RB200" }
                ],
                "trade_durations": [
                    {
                        "durations": [{ "display_name": "No Expiry", "max": 0, "min": 0, "name": "no_expiry" }],
                        "trade_type": { "display_name": "Multiply Up/Multiply Down", "name": "multiplier" }
                    }
                ]
            }
        ],
        "market": { "display_name": "Derived", "name": "synthetic_index" },
        "submarket": { "display_name": "Range Break Indices", "name": "range_index" }
    },
    {
        "data": [
            {
                "symbol": [
                    { "display_name": "Jump 10 Index", "name": "JD10" },
                    { "display_name": "Jump 25 Index", "name": "JD25" },
                    { "display_name": "Jump 50 Index", "name": "JD50" },
                    { "display_name": "Jump 75 Index", "name": "JD75" },
                    { "display_name": "Jump 100 Index", "name": "JD100" }
                ],
                "trade_durations": [
                    {
                        "durations": [
                            { "display_name": "Ticks", "max": 10, "min": 1, "name": "ticks" },
                            { "display_name": "Seconds", "max": 86400, "min": 15, "name": "s" },
                            { "display_name": "Minutes", "max": 1440, "min": 1, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" },
                            { "display_name": "Days", "max": 365, "min": 1, "name": "days" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall", "name": "rise_fall" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 2, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall (Forward Start)", "name": "rise_fall_forward" }
                    },
                    {
                        "durations": [
                            { "display_name": "Ticks", "max": 10, "min": 1, "name": "ticks" },
                            { "display_name": "Seconds", "max": 86400, "min": 15, "name": "s" },
                            { "display_name": "Minutes", "max": 1440, "min": 1, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" },
                            { "display_name": "Days", "max": 365, "min": 1, "name": "days" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall Equal", "name": "rise_fall_equal" }
                    },
                    {
                        "durations": [
                            { "display_name": "Minutes", "max": 1440, "min": 2, "name": "m" },
                            { "display_name": "Hours", "max": 24, "min": 1, "name": "h" }
                        ],
                        "trade_type": { "display_name": "Rise/Fall Equal (Forward Start)", "name": "rise_fall_equal_forward" }
                    },
                    {
                        "durations": [{ "display_name": "Ticks", "max": 10, "min": 1, "name": "ticks" }],
                        "trade_type": { "display_name": "Digits", "name": "digits" }
                    },
                    {
                        "durations": [{ "display_name": "No Expiry", "max": 0, "min": 0, "name": "no_expiry" }],
                        "trade_type": { "display_name": "Multiply Up/Multiply Down", "name": "multiplier" }
                    }
                ]
            }
        ],
        "market": { "display_name": "Derived", "name": "synthetic_index" },
        "submarket": { "display_name": "Jump Indices", "name": "jump_index" }
    },
    {
        "data": [
            {
                "symbol": [
                    { "display_name": "BTC/USD", "name": "cryBTCUSD" },
                    { "display_name": "ETH/USD", "name": "cryETHUSD" }
                ],
                "trade_durations": [
                    {
                        "durations": [{ "display_name": "No Expiry", "max": 0, "min": 0, "name": "no_expiry" }],
                        "trade_type": { "display_name": "Multiply Up/Multiply Down", "name": "multiplier" }
                    }
                ]
            }
        ],
        "market": { "display_name": "Cryptocurrencies", "name": "cryptocurrency" },
        "submarket": { "display_name": "Cryptocurrencies", "name": "non_stable_coin" }
    }
];

// Add 'underlying' alias to 'symbol' array for backward v3 compatibility
durations.forEach(market => {
    if (market.data) {
        market.data.forEach(d => {
            if (d.symbol && !d.underlying) {
                // Keep both to satisfy v3 ('underlying') and v4 ('symbol')
                d.underlying = d.symbol;
            }
        });
    }
});

export default durations;
